import React from 'react'
import ServiceLayout from 'components/ServiceLayout'

const BLOCKS = [
  {
    title: 'Planejamento de Conteúdo',
    desc: 'Um calendário editorial pensado a partir do comportamento do seu público.',
    items: [
      'Diagnóstico de público e concorrência',
      'Definição de pilares e formatos',
      'Copywriting estratégico',
      'Calendário editorial completo',
    ],
  },
  {
    title: 'Produção & Design',
    desc: 'Criativos que traduzem a identidade da marca em cada post.',
    items: [
      'Design de posts e carrosséis',
      'Roteiros para Reels e Stories',
      'Identidade visual aplicada ao feed',
      'Desenvolvimento templates editáveis',
    ],
  },
  {
    title: 'Gestão de Comunidade',
    desc: 'Transformar seguidores em relacionamento real com a marca.',
    items: [
      'Publicação e agendamento',
      'Relatório de performance mensal',
      'Estratégia de crescimento orgânico',
      'Protocolo de atendimento humanizado',
    ],
  },
]

const STEPS = [
  { title: 'Diagnóstico', desc: 'Analisamos suas redes atuais, público e concorrência.' },
  { title: 'Estratégia', desc: 'Definimos pilares de conteúdo, tom de voz e metas.' },
  { title: 'Produção', desc: 'Criamos e publicamos o conteúdo com identidade consistente.' },
  { title: 'Otimização', desc: 'Analisamos resultados e ajustamos a estratégia mensalmente.' },
]

function ServiceSocialMedia() {
  return (
    <ServiceLayout
      pageTitle='Agência Dorac - Mídias Sociais'
      eyebrow='Mídias Sociais'
      title='Presença estratégica que constrói comunidade'
      subtitle='Gerenciamos suas redes sociais de forma estratégica, transformando seguidores em comunidade e comunidade em clientes.'
      intro='Cada post nasce de uma leitura de comportamento: o que o seu público sente, precisa ouvir e está pronto para escutar. Por isso nossa gestão não é sobre volume, é sobre relevância, consistência e relacionamento real com o seu público.'
      blocks={BLOCKS}
      steps={STEPS}
      ctaText='Quero gestão de redes sociais'
    />
  )
}

export default ServiceSocialMedia
